<script setup lang="ts">
defineOptions({
  name: 'UIPasswordProtectedForm',
})

const password = defineModel<string>()
</script>

<template>
  <form
    id="password-protected-form"
    method="post"
    class="password-protected-form"
    autocomplete="off"
  >
    <label
      for="page-password"
      class="password-protected-form__label sr-only"
    >
      Password
      <span class="password-protected-form__asterisk">*</span>
    </label>
    <input
      id="page-password"
      v-model="password"
      name="page-password"
      required
      type="password"
      class="password-protected-form__input"
      placeholder="Enter password to access the page."
    >
    <UIButton
      type="submit"
      variant="primary"
      class="password-protected-form__button"
    >
      Submit
    </UIButton>
  </form>
</template>

<style scoped lang="scss">
.password-protected-form {
  @apply w-full max-w-96 mx-auto flex flex-col;

  &__label {
    @apply block text-sm mb-1;
  }

  &__asterisk {
    @apply text-red-500;
  }

  &__input {
    @apply appearance-none w-full px-4 py-3 rounded-full border bg-transparent;
  }

  &__button {
    @apply mx-auto mt-6;
  }
}
</style>
